import 'babel-polyfill'

import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'

import './selects'
import './content'
import './load-more'
import './front-page'
import './header'
import './jaotama'
import './modals'

import './ad-tracking'
import './announcement'

import './article'
import './podcast'

import './fancybox'

import './newsletter-popup'
import './survey-popup'


jQuery('.content iframe').reframe()

